import { z } from 'zod'
import { oc } from '@orpc/contract'

export const finalizeSessionResponseSchema = z.object({
  sessionId: z.string(),
  transcriptDocumentReferenceId: z.string(),
})
export type FinalizeSessionResponse = z.infer<typeof finalizeSessionResponseSchema>

export const scribeFinalizeSession = oc
  .route({ method: 'POST', path: '/v2/scribe/sessions/{encounterId}/finalize' })
  .input(z.object({ encounterId: z.string(), sessionId: z.string().min(1) }))
  .output(finalizeSessionResponseSchema)
